import React from 'react';
import StyledText from 'components/Helpers/StyledText/StyledText';

const Bildtext = props => {
  const styles = require('./Bildtext.scss');
  var { text, foto, credit, style} = props;
  return (
      (text || foto || credit) &&
      <figcaption className={styles.caption} style={style}>
        {text && <StyledText className={styles.captionText}>{text}</StyledText>}
        {foto && <StyledText className={styles.captionCredit}>{" Foto: " + foto}</StyledText>}
        {credit && <StyledText className={styles.captionCredit}>{" " + credit}</StyledText>}
      </figcaption> || <noscript/>
  );
};

export default Bildtext;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/Bildtext/Bildtext.js
 **/